/*
 * Simplissimo event transmitter, we will
 * use it to gradually replace the redux store
 */
/* eslint @typescript-eslint/no-unsafe-function-type: 0 */
/* eslint @typescript-eslint/no-explicit-any: 0 */

interface TinyEmitter {
  on(event: string, callback: Function, ctx?: any): this;
  once(event: string, callback: Function, ctx?: any): this;
  emit(event: string, ...args: any[]): this;
  off(event: string, callback?: Function): this;
}

import emitter from "tiny-emitter/instance";

const typedEmitter = emitter as unknown as TinyEmitter;

const eventBus: {
  $on: TinyEmitter["on"];
  $once: TinyEmitter["once"];
  $off: TinyEmitter["off"];
  $emit: TinyEmitter["emit"];
} = {
  $on: (...args) => typedEmitter.on(...args),
  $once: (...args) => typedEmitter.once(...args),
  $off: (...args) => typedEmitter.off(...args),
  $emit: (...args) => typedEmitter.emit(...args),
};

export default eventBus;
